/**
 * Referral settings, written as three portal-metadata keys that core reads
 * live (core-prod `features/clinic/portal/referrals`), so no redeploy:
 * `REFERRALS_ENABLED` (must be a real boolean), `REFERRAL_CREDIT_AMOUNT_CENTS`
 * and `REFERRAL_MAX_REWARDS_PER_REFERRER` (0 = no cap; Core's merge cannot
 * delete a key, so "no cap" is written as 0 rather than removed).
 */
export function referralFormFromDoc(doc) {
  const cents = Number(doc?.REFERRAL_CREDIT_AMOUNT_CENTS)
  const cap = Number(doc?.REFERRAL_MAX_REWARDS_PER_REFERRER)
  return {
    enabled: doc?.REFERRALS_ENABLED === true,
    amount: Number.isFinite(cents) && cents > 0 ? String(cents / 100) : '',
    cap: Number.isInteger(cap) && cap > 0 ? String(cap) : '',
  }
}

export function validateReferralForm(form, doc) {
  const amount = form.amount.trim()
  const cap = form.cap.trim()
  const dollars = Number(amount)
  // A pattern, not float math: 0.29 * 100 is 28.999…, never exactly 29.
  if (amount && !(/^\d+(\.\d{1,2})?$/.test(amount) && dollars > 0)) {
    return { error: 'Credit must be a dollar amount, like 25 or 12.50.' }
  }
  if (cap && !/^\d+$/.test(cap)) return { error: 'Reward limit must be a whole number.' }
  if (form.enabled && !amount) return { error: 'Set a credit amount to turn referrals on.' }
  if (form.enabled && !String(doc?.INTAKE_BASE_URL || '').trim()) {
    return { error: 'Set INTAKE_BASE_URL in metadata to turn referrals on.' }
  }
  const value = {
    REFERRALS_ENABLED: form.enabled,
    REFERRAL_MAX_REWARDS_PER_REFERRER: cap ? Number(cap) : 0,
  }
  if (amount) value.REFERRAL_CREDIT_AMOUNT_CENTS = Math.round(dollars * 100)
  return { value }
}
